import { render, staticRenderFns } from "./StoreRoleFloatBtns.vue?vue&type=template&id=053be6fc&"
import script from "./StoreRoleFloatBtns.vue?vue&type=script&lang=js&"
export * from "./StoreRoleFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports